import React from "react";

const Document = () => {
  return (
    <svg width="52" height="52" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M31.6667 5H8.33333C6.48333 5 5 6.48333 5 8.33333V31.6667C5 32.5507 5.35119 33.3986 5.97631 34.0237C6.60143 34.6488 7.44928 35 8.33333 35H31.6667C32.5507 35 33.3986 34.6488 34.0237 34.0237C34.6488 33.3986 35 32.5507 35 31.6667V8.33333C35 6.48333 33.5 5 31.6667 5Z" fill="#69A8F8" />
      <path fillRule="evenodd" clipRule="evenodd" d="M11.6667 28.3333H23.3333V25H11.6667V28.3333ZM11.6667 21.6667H28.3333V18.3333H11.6667V21.6667ZM11.6667 15H28.3333V11.6667H11.6667V15Z" fill="white" />
    </svg>
  );
};

export default Document;
